<template>
  <div>
    <el-skeleton class="width100" :loading="loading" animated :throttle="500">
      <template slot="template">
        <div class="toolbtn flex">
          <switchcore></switchcore>
          <el-tooltip class="item" effect="dark" content="刷新" placement="top">
            <div @click="refresh()" class="cursorpointer margin-top10">
              <img
                src="@/assets/barsvg/icon／12sx(1).png"
                style="position: relative; top: 2px"
                alt=""
              />
              <span class="f12 pad-left5" style="color: #969eac">刷新</span>
            </div>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="返回" placement="top">
            <callback></callback>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="显隐列"
            placement="top"
            v-if="columns"
          >
            <div @click="showColumn()" class="cursorpointer margin-top10">
              <img
                src="@/assets/barsvg/icon／12xsl.png"
                style="position: relative; top: 2px"
                alt=""
              />
              <span class="f12 pad-left5" style="color: #969eac">显隐列</span>
            </div>
          </el-tooltip>
        </div>
        <!-- 检索 -->
        <div
          class="backwhite border-rd3 flexleft"
          style="min-height: 120px"
          v-if="serchkey"
        >
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            size="small"
            label-width="100px"
            class="demo-ruleForm width90 flexleft"
          >
            <el-form-item label="项目名称">
              <el-input
                placeholder="请输入项目名称"
                v-model="ruleForm.pipo"
              ></el-input>
            </el-form-item>
            <el-form-item label="实施主体">
              <el-input
                placeholder="请输入实施主体"
                v-model="ruleForm.name"
              ></el-input>
            </el-form-item>
            <el-form-item label="立项时间">
              <el-date-picker
                v-model="ruleForm.number"
                :editable="false"
                value-format="yyyy-MM-dd"
                type="daterange"
                style="width: 50%"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div class="width96 margin-auto flex-betweennowrap pad-bot10">
            <p>
              <el-button type="primary" @click="submitForm()">检 索</el-button>
              <el-button @click="resetForm()" class="resetbtn">重 置</el-button>
            </p>
            <span class="attention f14" @click="toindustrialaddfication()"
              >新 增</span
            >
          </div>
        </div>

        <div
          class="
            width100
            backwhite
            margin-top15
            pad-top20
            border-rd3
            alldigitalt
          "
          v-if="total != 0"
        >
          <el-table :data="page" stripe class="eltable width98 margin-auto f14">
            <el-table-column
              label="项目名称"
              align="left"
              width="350"
              v-if="columns[0].visible"
            >
              <template slot-scope="scope">
                <span
                  class="bluecolor cursorpointer"
                  @click="toaddPersonnel(scope.row)"
                  >{{ scope.row.title }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="项目编号"
              align="left"
              prop="project_number"
              v-if="columns[1].visible"
            />
            <el-table-column
              label="项目进度"
              align="left"
              v-if="columns[2].visible"
            >
              <template slot-scope="scope">
                <span
                  class="width20 progress"
                  :class="
                    scope.row.progress == '研究阶段'
                      ? 'change1'
                      : scope.row.progress == '开发阶段'
                      ? 'change2'
                      : ''
                  "
                  >{{ scope.row.progress }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="立项时间"
              align="left"
              prop="start_date"
              v-if="columns[3].visible"
            />
            <el-table-column
              label="预期结束"
              align="left"
              prop="end_date"
              v-if="columns[4].visible"
            />
            <el-table-column
              label="承担部门"
              align="left"
              prop="research_dev_title"
              v-if="columns[5].visible"
            />
            <el-table-column
              label="项目负责人"
              align="left"
              prop="manager_name"
              v-if="columns[6].visible"
            />
            <el-table-column
              label="立项状态"
              align="center"
              prop="approval_text"
              v-if="columns[7].visible"
            />
            <el-table-column
              label="结题状态"
              align="center"
              v-if="columns[8].visible"
            >
              <template slot-scope="scope">
                <span class="width100">{{
                  scope.row.finish_status == 0
                    ? "未申请"
                    : scope.row.finish_status == 1
                    ? "待审批"
                    : "已结题"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              align="center"
              width="220"
              class-name="small-padding fixed-width"
              v-if="columns[9].visible"
            >
              <template slot-scope="scope">
                <div class="flex cursorpointer">
                  <span
                    style="color: #52c5cb"
                    @click="toaddPersonnel(scope.row)"
                    >详情</span
                  >
                  <span
                    class="pad-left10"
                    style="color: #52c5cb"
                    @click="todetails(scope.row)"
                    >修改</span
                  >
                  <span
                    class="pad-left10"
                    style="color: #52c5cb"
                    @click="removepro(scope.row)"
                    >删除</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div
            class="
              flex-betweennowrap
              pad-top20 pad-bot20 pad-left10 pad-right10
              width98
              margin-auto
            "
          >
            <span class="f14"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
        <!-- 新增 -->
        <el-dialog
          title=""
          :visible.sync="dialogVisibleadd"
          :close-on-click-modal="false"
          :show-close="true"
          :center="true"
          :modal="true"
          :modal-append-to-body="true"
          :append-to-body="true"
          width="40%"
          class="errorboxs"
        >
          <scienceaddfication></scienceaddfication>
        </el-dialog>
        <!-- 修改 -->
        <el-dialog
          title=""
          :visible.sync="dialogVisiblemodify"
          :close-on-click-modal="false"
          :show-close="true"
          :center="true"
          :modal="true"
          :modal-append-to-body="true"
          :append-to-body="true"
          width="40%"
          class="errorboxs"
        >
          <sciencemodify></sciencemodify>
        </el-dialog>

        <el-dialog
          title=""
          :visible.sync="dialogVisiblenull"
          :close-on-click-modal="false"
          :show-close="true"
          :center="true"
          :modal="true"
          :modal-append-to-body="true"
          :append-to-body="true"
          width="25%"
          class="errorbox"
        >
          <p class="textalign-left f16">提示</p>
          <div class="textalign-left margin-top10">
            <span class="errormessage">{{ errormessage }}</span>
          </div>
          <span slot="footer" class="dialog-footer">
            <span @click="dialogVisiblenull = false" class="errorbutton">
              确 定
            </span>
          </span>
        </el-dialog>
        <el-dialog
          :title="title"
          :visible.sync="open"
          append-to-body
          width="40%"
        >
          <el-transfer
            :titles="['全选', '全选']"
            v-model="value"
            :data="columns"
            @change="dataChange"
          ></el-transfer>
        </el-dialog>
      </template>
    </el-skeleton>
  </div>
</template>
 <script>
import { researchprojects, designDelete } from "@/api/Center/Center.api";
import callback from "@/components/callback.vue";
import scienceaddfication from "./Science-addfication.vue";
import sciencemodify from "./Science-ficationmodify.vue";
import BUS from "@/BUS/BUS";
import switchcore from "@/components/switchcore.vue";
export default {
  data() {
    return {
      loading: true,
      errormessage: "",
      // 显隐数据
      value: [],
      // 弹出层标题
      title: "显示/隐藏",
      // 是否显示弹出层
      open: false,
      dialogVisiblenull: false,
      dialogVisibleadd: false,
      dialogVisiblemodify: false,
      serchkey: true,
      ruleForm: {
        pipo: "",
        number: "",
        name: "",
      },
      thisNum: 1,
      currentPage: 1,
      page: [],
      total: 0,
      per_page: 0,
      progress: "",
      columns: [
        { key: 0, label: `项目名称`, visible: true },
        { key: 1, label: `项目编号`, visible: true },
        { key: 2, label: `项目进度`, visible: true },
        { key: 3, label: `立项时间`, visible: true },
        { key: 4, label: `预期结束`, visible: true },
        { key: 5, label: `承担部门`, visible: true },
        { key: 6, label: `项目负责人`, visible: true },
        { key: 7, label: `立项状态`, visible: true },
        { key: 8, label: `结题状态`, visible: true },
        { key: 9, label: `操作`, visible: true },
      ],
    };
  },
  components: {
    callback,
    scienceaddfication,
    sciencemodify,
    switchcore,
  },
  methods: {
    // 右侧列表元素变化
    dataChange(data) {
      for (let item in this.columns) {
        const key = this.columns[item].key;
        this.columns[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumn() {
      this.open = true;
    },
    // 检索
    submitForm() {
      if (this.ruleForm.number[0] == undefined) {
        researchprojects({
          research_dev_title: this.ruleForm.name,
          _keywords: this.ruleForm.pipo,
          page: this.thisNum,
        }).then((res) => {
          if (res.data.code == 200) {
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
            this.page.forEach((i) => {
              if (i.progress == 1) {
                i.progress = "研究阶段";
              } else if (i.progress == 2) {
                i.progress = "开发阶段";
              }
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        researchprojects({
          start_date:
            this.ruleForm.number[0] + " " + "-" + " " + this.ruleForm.number[1],
          research_dev_title: this.ruleForm.name,
          _keywords: this.ruleForm.pipo,
          page: this.thisNum,
        }).then((res) => {
          if (res.data.code == 200) {
            this.pagination = true;
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
            this.page.forEach((i) => {
              if (i.progress == 1) {
                i.progress = "筹备";
              } else if (i.progress == 2) {
                i.progress = "立项";
              } else if (i.progress == 3) {
                i.progress = "研发中";
              } else if (i.progress == 4) {
                i.progress = "结项";
              } else if (i.progress == 5) {
                i.progress = "已完成";
              }
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    // 第一个分页
    handleSizeChange(val) {
      if (this.ruleForm.pipo != "" && this.ruleForm.pipo != null) {
        researchprojects({
          title: this.ruleForm.pipo,
          author: this.ruleForm.name,
          start_date:
            this.ruleForm.number[0] + " " + "-" + " " + this.ruleForm.number[1],
          page: this.thisNum,
          limit: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
            this.page.forEach((i) => {
              if (i.progress == 1) {
                i.progress = "研究阶段";
              } else if (i.progress == 2) {
                i.progress = "开发阶段";
              }
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        researchprojects({
          title: window.sessionStorage.getItem("titlepipos"),
          author: window.sessionStorage.getItem("authornames"),
          start_date: window.sessionStorage.getItem("startdates"),
          page: this.thisNum,
          limit: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
            this.page.forEach((i) => {
              if (i.progress == 1) {
                i.progress = "研究阶段";
              } else if (i.progress == 2) {
                i.progress = "开发阶段";
              }
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    currentchange(val) {
      window.sessionStorage.setItem("scienceval", val);
      if (this.ruleForm.pipo != "" && this.ruleForm.pipo != null) {
        researchprojects({
          title: this.ruleForm.pipo,
          author: this.ruleForm.name,
          start_date:
            this.ruleForm.number[0] + " " + "-" + " " + this.ruleForm.number[1],
          page: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
            this.page.forEach((i) => {
              if (i.progress == 1) {
                i.progress = "研究阶段";
              } else if (i.progress == 2) {
                i.progress = "开发阶段";
              }
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        researchprojects({
          title: window.sessionStorage.getItem("titlepipos"),
          author: window.sessionStorage.getItem("authornames"),
          start_date: window.sessionStorage.getItem("startdates"),
          page: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
            this.page.forEach((i) => {
              if (i.progress == 1) {
                i.progress = "筹备";
              } else if (i.progress == 2) {
                i.progress = "立项";
              } else if (i.progress == 3) {
                i.progress = "研发中";
              } else if (i.progress == 4) {
                i.progress = "结项";
              } else if (i.progress == 5) {
                i.progress = "已完成";
              }
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    // input重 置
    resetForm() {
      this.ruleForm.pipo = "";
      this.ruleForm.number = "";
      this.ruleForm.name = "";
      researchprojects({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.page.forEach((i) => {
            if (i.progress == 1) {
              i.progress = "研究阶段";
            } else if (i.progress == 2) {
              i.progress = "开发阶段";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    removepro(row) {
      this.$confirm("此操作将删除此项目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          designDelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 详情
    toaddPersonnel(row) {
      window.sessionStorage.setItem("centerNums", row.id);
      BUS.$emit("centerNums", row.id);
      this.$router.push({
        path: "/development-Administration/Science-addPersonnel",
      });
    },
    // 添加项目
    toindustrialaddfication() {
      this.dialogVisibleadd = true;
    },
    // 修改
    todetails(row) {
      this.dialogVisiblemodify = true;
      window.sessionStorage.setItem("centerNums", row.id);
      BUS.$emit("centerNums", row.id);
    },

    refresh() {
      this.$loading.show(); // 显示loading
      researchprojects({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.page.forEach((i) => {
            if (i.progress == 1) {
              i.progress = "研究阶段";
            } else if (i.progress == 2) {
              i.progress = "开发阶段";
            }
          });
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    researchprojects({
      page: this.thisNum,
      // research_dev_title: "测试",
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagination = true;
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
        this.page.forEach((i) => {
          if (i.progress == 1) {
            i.progress = "研究阶段";
          } else if (i.progress == 2) {
            i.progress = "开发阶段";
          }
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("sciencepro", (data) => {
      if (data == "null") {
        this.dialogVisibleadd = null;
        this.dialogVisiblemodify = null;
      }
    });
  },
};
</script>
<style scoped>
.editor >>> .el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.progress {
  height: 10px;
}
.hovercont:hover {
  background: #f7f9fc;
}
.change1 {
  color: #7b83ea;
}
.change2 {
  color: #f96d68;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
.preservation {
  background: #409eff;
  color: white;
  width: 80px;
  text-align: center;
  border-radius: 5px;
  line-height: 30px;
  float: right;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
</style>